export function cleanupString(input) {
  // Remove non-alphanumeric characters using regular expression
  const cleanString = input.replace(/[^a-zA-Z0-9-]/g, "");

  return cleanString;
}
